import { render, staticRenderFns } from "./giftRecharge.vue?vue&type=template&id=77d33be4"
import script from "./giftRecharge.vue?vue&type=script&lang=js"
export * from "./giftRecharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports